import { css } from '@emotion/react'

export const font300 = css`
  font-family: Hiragino Sans;
  font-weight: 300;
  font-style: normal;
  font-size: 14px;
`

export const font600 = css`
  font-family: Hiragino Sans;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
`
